<payee-popup title="Felhasználó szerkesztése">
  @if (initLoading()) {
    <mat-progress-spinner
      color="accent"
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }
  @if (!initLoading()) {
    <form [formGroup]="formGroup">
      <!-- Email -->
      <payee-form-field width="max">
        <span payee-label>Felhasználó email címe</span>
        <input
          payee-input
          formControlName="email"
        />
        @if (email.dirty && email.invalid) {
          <ng-container payee-error>
            @if (email.hasError("required")) {
              <span>A mező kitöltése kötelező</span>
            }
            @if (email.hasError("email")) {
              <span>Létező email címet adjon meg</span>
            }
            @if (email.hasError("backend")) {
              <span>
                {{ email.getError("backend") }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <!-- Name -->
      <payee-form-field width="max">
        <span payee-label>Felhasználó neve</span>
        <input
          payee-input
          formControlName="name"
        />
        @if (name.dirty && name.invalid) {
          <ng-container payee-error>
            @if (name.hasError("required")) {
              <span>A mező kitöltése kötelező</span>
            }
          </ng-container>
        }
      </payee-form-field>
      <!-- Phone -->
      <payee-form-field width="max">
        <span payee-label>Felhasználó telefonszáma</span>
        <input
          payee-input
          formControlName="phone"
        />
        @if (phone.dirty && phone.invalid) {
          <ng-container payee-error>
            @if (phone.hasError("required")) {
              <span>A mező kitöltése kötelező</span>
            }
            @if (phone.hasError("invalidPhoneNumber")) {
              <span>Létező telefonszámot adjon meg</span>
            }
          </ng-container>
        }
      </payee-form-field>
      <div class="user-roles flex column">
        <span>Felhasználó jogosultságai</span>
        @for (role of roleOptions; track role.name) {
          <mat-checkbox
            [checked]="isRoleSelected(role.name)"
            (change)="toggleRole($event, role.name)"
          >
            {{ role.name }}
          </mat-checkbox>
        }
      </div>
      <div class="user-clients">
        <div class="flex vcenter client-filter">
          <payee-form-field>
            <span payee-label>
              <div class="flex vcenter client-filter-label">
                <span>Felhasználó által elérhető hitelezők</span>
                @if (clientsLoading) {
                  <mat-progress-spinner
                    diameter="24"
                    mode="indeterminate"
                    color="accent"
                  ></mat-progress-spinner>
                }
              </div>
              @if (initLoading()) {
                <mat-progress-spinner
                  color="accent"
                  mode="indeterminate"
                  diameter="24"
                ></mat-progress-spinner>
              }
            </span>
            <input
              payee-input
              placeholder="Kezdjen el gépelni..."
              [formControl]="clientFilter"
              [matAutocomplete]="auto"
              (input)="onClientSearchInput($event)"
            />
          </payee-form-field>
          <mat-autocomplete
            #auto="matAutocomplete"
            [requireSelection]="false"
          >
            @for (client of filteredClients; track client.uuid) {
              <mat-option
                [value]="clientFilter.value"
                (onSelectionChange)="selectClient(client)"
              >
                {{ client.name }}
              </mat-option>
            }
          </mat-autocomplete>
          <button
            payee-mini-icon-button
            type="button"
            color="white"
            class="client-clear-button"
            (click)="clearClientFilter()"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </div>
        @for (client of clients.value; track client.uuid) {
          <div class="flex vcenter client-row">
            <div class="client-name">{{ client.name }}</div>
            <button
              payee-mini-icon-button
              type="button"
              color="white"
              (click)="unselectClient(client)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
        @if (clients.value.length === 0) {
          <div class="flex vcenter client-row">Nincs hozzárendelt hitelező</div>
        }
      </div>
      @if (userCanViewAttorney) {
        <div class="attorney-law-firms">
          <div class="flex vcenter law-firm-filter">
            <payee-form-field>
              <span payee-label>
                <div class="flex vcenter law-firm-filter-label">
                  <span>Ügyvédi irodák</span>
                  @if (lawFirmsLoading) {
                    <mat-progress-spinner
                      diameter="24"
                      mode="indeterminate"
                      color="accent"
                    ></mat-progress-spinner>
                  }
                </div>
                @if (initLoading()) {
                  <mat-progress-spinner
                    color="accent"
                    mode="indeterminate"
                    diameter="24"
                  ></mat-progress-spinner>
                }
              </span>
              <input
                payee-input
                placeholder="Kezdjen el gépelni..."
                [formControl]="lawFirmFilter"
                [matAutocomplete]="auto"
                (input)="onLawFirmSearchInput($event)"
              />
              @if (law_firms.invalid) {
                <ng-container payee-error>
                  @if (law_firms.hasError("backend")) {
                    <span color="alert-red">
                      {{ law_firms.getError("backend") }}
                    </span>
                  }
                </ng-container>
              }
            </payee-form-field>
            <mat-autocomplete
              #auto="matAutocomplete"
              [requireSelection]="false"
            >
              @for (lawFirm of lawFirmOptions; track lawFirm.id) {
                <mat-option
                  [value]="clientFilter.value"
                  (onSelectionChange)="selectLawFirm(lawFirm)"
                >
                  {{ lawFirm.name }}
                </mat-option>
              }
            </mat-autocomplete>
            <button
              payee-mini-icon-button
              type="button"
              color="white"
              class="law-firm-clear-button"
              (click)="clearLawFirmFilter()"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
          @for (lawFirm of law_firms.value; track lawFirm.id) {
            <div class="flex vcenter law-firm-row">
              <div class="law-firm-name">{{ lawFirm.name }}</div>
              <button
                payee-mini-icon-button
                type="button"
                color="white"
                (click)="unselectLawFirm(lawFirm)"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            </div>
          }
          @if (law_firms.value.length === 0) {
            <div class="flex vcenter law-firm-row">Nincs hozzárendelt ügyvédi iroda</div>
          }
        </div>
      }
      @if (userCanViewAttorney) {
        <div class="attorney-countries flex column">
          <span class="attorney-countries-title">Ügyvéd által elérhető országok</span>
          @for (country of attorneyCountryOptions; track country.iso) {
            <mat-checkbox
              [checked]="isCountrySelected(country)"
              (change)="toggleCountry($event, country)"
            >
              {{ country.name }}
            </mat-checkbox>
          }
        </div>
      }
    </form>
  }
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="formGroup.invalid"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      (click)="cancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
